import { Injectable, inject } from '@angular/core';
import { setUserTheme } from './user.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { UserSettingsService } from 'src/app/shared/services/user-settings.service';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class UserEffects {
  private actions$ = inject(Actions);
  constructor() {}
  userTheme$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setUserTheme),
      exhaustMap(({theme}) => {
        UserSettingsService.setLocalUserTheme(theme);

        return EMPTY as Observable<Action>;
      })
    )
  );
}
